import { render, staticRenderFns } from "./modalVerMas.vue?vue&type=template&id=0bf02dec&scoped=true&"
import script from "./modalVerMas.vue?vue&type=script&lang=js&"
export * from "./modalVerMas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf02dec",
  null
  
)

export default component.exports